'use client';

import Image from 'next/image';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

interface OtterzLogoProps {
  size?: number;
}
export function OtterzLogo({ size = 24 }: OtterzLogoProps) {
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // After mount, we can access the theme
  useEffect(() => {
    setMounted(true);
  }, []);

  const shouldInvert = mounted && (
    theme === 'dark' || (theme === 'system' && systemTheme === 'dark')
  );

  return (
    <Image
        src="/logo.svg"
        alt="Otterz"
        width={size}
        height={size}
        className={`$ flex-shrink-0`}
      />
  );
}

// Keep the old export for backward compatibility during migration
export const KortixLogo = OtterzLogo;
